import "./News.css";
import "../Team/Team.css";

import aug26_1 from "../../assets/images/news/image1.jpeg";
import aug26_2 from "../../assets/images/news/image2.jpg";
import aug26_3 from "../../assets/images/news/image3.jpg";
import aug26_4 from "../../assets/images/news/image4.jpeg";
import jun26_1 from "../../assets/images/news/image5.jpg";
import may26_1 from "../../assets/images/news/image6.jpeg";
import may26_2 from "../../assets/images/news/image7.jpg";
import apr26_1 from "../../assets/images/news/image8.png";
import aug25_1 from "../../assets/images/news/image9.jpg";
import aug25_2 from "../../assets/images/news/image10.jpg";
import aug25_3 from "../../assets/images/news/image11.jpg";
import aug25_4 from "../../assets/images/news/image12.png";
import mar25_1 from "../../assets/images/news/image13.png";
import mar25_2 from "../../assets/images/news/image14.png";

function NewsCard({ date, text, images = [] }) {
  return (
    <div className="news-item-card">
      <div className="news-card-text">
        <strong>{date}</strong>: {text}
      </div>
      {images.length > 0 && (
        <div className="news-card-images">
          {images.map((src, i) => (
            <img key={i} src={src} alt={`${date} event ${i + 1}`} />
          ))}
        </div>
      )}
    </div>
  );
}

function News() {
  return (
    <div>
      <div className="news-grid">
        <div className="grid-text">
          <div className="publication-header" style={{ fontSize: "50px" }}>
            News & Updates
          </div>
        </div>
        <div />
      </div>

      <div className="team-profile-section">
        <div className="header" style={{ marginBottom: "2rem" }}>
          <u>Latest Updates</u>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem", width: "100%" }}>

          <NewsCard
            date="August 2026"
            text={<>A warm welcome to <em>Gloria</em>, <em>Gabriella</em>, <em>Nivey</em>, and <em>Bernard</em>! Gloria joins the lab as a PhD student, while Gabriella, Nivey, and Bernard join as undergraduate and master's researchers, respectively. We are excited to have all of them on board!</>}
            images={[aug26_1, aug26_2, aug26_3, aug26_4]}
          />

          <NewsCard
            date="July 2026"
            text={<><em>Phan Anh</em> presents his summer research at the Odyssey Research Symposium. Congratulations and great job, Phan Anh!</>}
          />

          <NewsCard
            date="July 2026"
            text="Anuvab is invited to deliver a talk at Mississippi State University."
          />

          <NewsCard
            date="June 2026"
            text={<>We are delighted to welcome <em>Puja</em> as the first postdoctoral researcher in the Das Lab!</>}
            images={[jun26_1]}
          />

          <NewsCard
            date="May 2026"
            text={<><em>Jia Yu</em> joins the lab for summer research through the CN Yang Scholar's Programme, while <em>Phan Anh</em> joins us through the Odyssey Programme. Welcome to both!</>}
            images={[may26_1, may26_2]}
          />

          <NewsCard
            date="April 2026"
            text="Anuvab receives the A*STAR Manufacturing, Trade & Connectivity Young Individual Research Grant (MTC-YIRG). We gratefully acknowledge A*STAR for supporting our research."
            images={[apr26_1]}
          />

          <NewsCard
            date="December 2025"
            text="Anuvab delivers an invited talk at the 7th Annual Peptides and Proteins Society Singapore Symposium (P2S2-2025)."
          />

          <NewsCard
            date="November 2025"
            text="Anuvab visits Jeju, South Korea, to give an invited talk at the International Symposium on Industrial Biotechnology and Bioprocessing (i-BioJ)."
          />

          <NewsCard
            date="August 2025"
            text="Anuvab gave an invited talk at the 10th Asia-Pacific Congress on Catalysis (APCAT-10) hosted in Singapore."
          />

          <NewsCard
            date="August 2025"
            text={<>The Das Lab officially begins to take shape as <em>Peiyu</em>, <em>Soumen</em>, <em>Shreyansh</em>, and <em>Jung Wei</em> join as its founding members!</>}
            images={[aug25_1, aug25_2, aug25_3, aug25_4]}
          />

          <NewsCard
            date="March 2025"
            text="A new chapter begins — Anuvab officially joins Nanyang Technological University and launches the Das Lab!"
            images={[mar25_1, mar25_2]}
          />

        </div>
      </div>
    </div>
  );
}

export default News;
